import kotlinx.serialization.Serializable

@Serializable
enum class LeadStatus { PENDING, APPROVED, REJECTED, REVIEWED }

@Serializable
data class RecruiterLead(
    val id: Int? = null,
    val leadType: String = "Recruiter",
    val companyName: String = "",
    val employerName: String = "",
    val designation: String = "",
    val employerDepartment: String = "",
    val totalVacancies: String = "",
    val companyEmail: String = "",
    val contactNumber: String = "",
    val companyAddress: String = "",
    val companyWebsite: String = "",
    val gstnNo: String = "",
    val requiredPosition: String = "",
    val recruitmentDepartment: String = "",
    val otherRecruitmentDepartment: String = "",
    val departmentVacancies: String = "",
    val offeredCtc: String = "",
    val experienceRequired: String = "",
    val qualification: String = "",
    val jobType: String = "",
    val otherJobType: String = "",
    val genderPreference: String = "",
    val joiningTimeline: String = "",
    val interviewMode: String = "",
    val skillsRequired: String = "",
    val hiringDescription: String = "",
    val specialNote: String = "",
    val status: LeadStatus = LeadStatus.PENDING,
    val createdAt: String? = null
)

@Serializable
data class CandidateLead(
    val id: Int? = null,
    val firstName: String = "",
    val middleName: String = "",
    val lastName: String = "",
    val phone: String = "",
    val alternateNo: String = "",
    val email: String = "",
    val temporaryAddress: String = "",
    val permanentAddress: String = "",
    val fieldExperience: String = "",
    val otherExperience: String = "",
    val totalExperience: String = "",
    val currentCtc: String = "",
    val expectedCtc: String = "",
    val currentIndustry: String = "",
    val otherCurrentIndustry: String = "",
    val expectedIndustry: String = "",
    val otherExpectedIndustry: String = "",
    val referenceLead: String = "",
    val keySkills: String = "",
    val currentLocation: String = "",
    val expectedLocations: String = "",
    val noticePeriod: String = "",
    val preferredJobType: String = "",
    val emailAlerts: Boolean = true,
    val resumeName: String = "",
    val paymentCommitment: String = "",
    val registrationFee: String = "499",
    val status: LeadStatus = LeadStatus.PENDING,
    val createdAt: String? = null
)

@Serializable
data class PaginatedResponse<T>(
    val items: List<T>,
    val totalCount: Long,
    val totalPages: Int,
    val currentPage: Int
)
